export const TEXT_ERROR_NAME = 'Вкажіть коректну електронну адресу';
export const TEXT_ERROR_PASSWORD = 'Пароль повинен містить один спеціальний символ,' +
    ' не менше одної літери та головної літери, число. Його довжина не менше 6 символів';
export const TEXT_ERROR_RE_PASSWORD = 'Введений пароль не співпадає';

export const TEXT_AUTH_EMAIL = 'Не коректна електронна адреса';
export const TEXT_AUTH_PASSWORD = 'Не коректний пароль';
export const TEXT_AUTH_USER = 'Такий користувач не зареєстрований';